import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';
import { LayoutModule, ShowMessageService, AuthInterceptorService, EnvironmentLabelModule } from 'ahm-angular';
import { environment } from '../environments/environment';
import { AppErrorInterceptorService } from './source/services/interceptors/error-interceptor.service';
import { MdbCookiesManagementService } from 'mdb-angular-cookies-management';
import { MdbStorageManagementService } from 'mdb-angular-storage-management';
import { MdbScrollStatusService } from 'mdb-angular-scroll-status';
import { ButtonModule } from 'primeng/button';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    LayoutModule,
    HttpClientModule,
    ToastModule,
    EnvironmentLabelModule,
    ButtonModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppErrorInterceptorService, multi: true },
    MessageService,
    ShowMessageService,
    MdbCookiesManagementService,
    MdbStorageManagementService,
    MdbScrollStatusService,
    { provide: 'env', useValue: environment }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
